module.exports = __webpack_public_path__ + "static/media/swiggy-logo.ba0c139e.svg";